"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  DialPad: ['dial-pad', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.568 2.591 A2.591 2.591 0 1 0 6.750 2.591 A2.591 2.591 0 1 0 1.568 2.591 Z', 'M9.377 2.591 A2.591 2.591 0 1 0 14.559 2.591 A2.591 2.591 0 1 0 9.377 2.591 Z', 'M19.841,5.182A2.591,2.591,0,1,0,17.25,2.591,2.594,2.594,0,0,0,19.841,5.182Z', 'M4.159,6.273A2.591,2.591,0,1,0,6.75,8.863,2.593,2.593,0,0,0,4.159,6.273Z', 'M11.968,6.273a2.591,2.591,0,1,0,2.59,2.59A2.593,2.593,0,0,0,11.968,6.273Z', 'M19.841,6.273a2.591,2.591,0,1,0,2.591,2.59A2.593,2.593,0,0,0,19.841,6.273Z', 'M4.159,12.546A2.591,2.591,0,1,0,6.75,15.137,2.594,2.594,0,0,0,4.159,12.546Z', 'M11.968,12.546a2.591,2.591,0,1,0,2.59,2.591A2.594,2.594,0,0,0,11.968,12.546Z', 'M9.377 21.409 A2.591 2.591 0 1 0 14.559 21.409 A2.591 2.591 0 1 0 9.377 21.409 Z', 'M19.841,12.546a2.591,2.591,0,1,0,2.591,2.591A2.594,2.594,0,0,0,19.841,12.546Z']],
  DialFinger: ['dial-finger', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.079,14.779,18,12.956V7.5a2,2,0,0,0-4,0v8.461l-.827-1.138a1.546,1.546,0,0,0-1.2-.558l-.991.019a1.476,1.476,0,0,0-1.3,2.179l3.735,6.773A1.464,1.464,0,0,0,14.7,24h6.387a1.476,1.476,0,0,0,1.378-.989l1.52-6.68A.461.461,0,0,0,24,16.22,1.435,1.435,0,0,0,23.079,14.779Z', 'M0.000 0.000 L4.000 0.000 L4.000 3.000 L-0.000 3.000 Z', 'M6.000 0.000 L10.000 0.000 L10.000 3.000 L6.000 3.000 Z', 'M0.000 5.000 L4.000 5.000 L4.000 8.000 L-0.000 8.000 Z', 'M6.000 5.000 L10.000 5.000 L10.000 8.000 L6.000 8.000 Z', 'M0.000 10.000 L4.000 10.000 L4.000 13.000 L-0.000 13.000 Z', 'M6.000 10.000 L10.000 10.000 L10.000 13.000 L6.000 13.000 Z', 'M12.000 0.000 L16.000 0.000 L16.000 3.000 L12.000 3.000 Z']],
  DialFinger1: ['dial-finger-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.000 1.751 A1.750 1.750 0 1 0 3.500 1.751 A1.750 1.750 0 1 0 0.000 1.751 Z', 'M5.000 1.751 A1.750 1.750 0 1 0 8.500 1.751 A1.750 1.750 0 1 0 5.000 1.751 Z', 'M10.000 1.751 A1.750 1.750 0 1 0 13.500 1.751 A1.750 1.750 0 1 0 10.000 1.751 Z', 'M0.000 6.751 A1.750 1.750 0 1 0 3.500 6.751 A1.750 1.750 0 1 0 0.000 6.751 Z', 'M5.000 6.751 A1.750 1.750 0 1 0 8.500 6.751 A1.750 1.750 0 1 0 5.000 6.751 Z', 'M10.000 6.751 A1.750 1.750 0 1 0 13.500 6.751 A1.750 1.750 0 1 0 10.000 6.751 Z', 'M0.000 11.751 A1.750 1.750 0 1 0 3.500 11.751 A1.750 1.750 0 1 0 0.000 11.751 Z', 'M5.000 11.751 A1.750 1.750 0 1 0 8.500 11.751 A1.750 1.750 0 1 0 5.000 11.751 Z', 'M19.5,17H17V11a2,2,0,0,0-4,0v8.443l-1.462-1.759A2,2,0,0,0,8.462,20.24l2.975,3.579a.5.5,0,0,0,.385.181H23.5a.5.5,0,0,0,.5-.5v-2A4.5,4.5,0,0,0,19.5,17Z']],
  DialPadAlternate: ['dial-pad-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.316,0A3.316,3.316,0,1,0,6.631,3.315,3.319,3.319,0,0,0,3.316,0Zm0,4.632A1.316,1.316,0,1,1,4.631,3.315,1.318,1.318,0,0,1,3.316,4.632Z', 'M11.964,0A3.316,3.316,0,1,0,15.28,3.315,3.319,3.319,0,0,0,11.964,0Zm0,4.632A1.316,1.316,0,1,1,13.28,3.315,1.319,1.319,0,0,1,11.964,4.632Z', 'M20.684,6.632a3.316,3.316,0,1,0-3.315-3.317A3.32,3.32,0,0,0,20.684,6.632Zm0-4.632a1.316,1.316,0,1,1-1.315,1.315A1.317,1.317,0,0,1,20.684,2Z', 'M3.316,8.685A3.315,3.315,0,1,0,6.631,12,3.319,3.319,0,0,0,3.316,8.685Zm0,4.63A1.315,1.315,0,1,1,4.631,12,1.316,1.316,0,0,1,3.316,13.315Z', 'M11.964,8.685A3.315,3.315,0,1,0,15.28,12,3.319,3.319,0,0,0,11.964,8.685Zm0,4.63A1.315,1.315,0,1,1,13.28,12,1.317,1.317,0,0,1,11.964,13.315Z', 'M20.684,8.685A3.315,3.315,0,1,0,24,12,3.319,3.319,0,0,0,20.684,8.685Zm0,4.63A1.315,1.315,0,1,1,22,12,1.316,1.316,0,0,1,20.684,13.315Z', 'M11.964,17.368a3.316,3.316,0,1,0,3.316,3.317A3.321,3.321,0,0,0,11.964,17.368Zm0,4.632a1.316,1.316,0,1,1,1.316-1.315A1.317,1.317,0,0,1,11.964,22Z']]
};
exports["default"] = _default;